import { render, staticRenderFns } from "./BaixaItemBemConsumoForm.vue?vue&type=template&id=2f11b38e&scoped=true"
import script from "./BaixaItemBemConsumoForm.vue?vue&type=script&lang=js"
export * from "./BaixaItemBemConsumoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f11b38e",
  null
  
)

export default component.exports